import {
    apiRequest,
    anakList,
    anakActive,
    anakInactive
} from "../../../../../../services/adapters/kepegawaian/anakService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", anakList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", anakInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", anakActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository